import { easepick, RangePlugin, LockPlugin } from '@easepick/bundle'
import moment from 'moment'

// eslint-disable-next-line no-undef
const object = vnObject

const input = document.getElementById('hero-date')
if (input) {
  new easepick.create({
    element: input,
    css: ['wp-content/themes/smdt/css/easepick.css'],
    lang: 'fr-FR',
    plugins: [RangePlugin, LockPlugin],
    grid: 2,
    calendars: 2,
    format: 'DD/MM/YYYY',
    RangePlugin: {
      tooltipNumber(num) {
        return num - 1
      },
      locale: {
        one: object.day,
        other: object.days,
      },
    },
    LockPlugin: {
      minDays: 15,
      minDate: new Date(),
    },
    setup(picker) {
      picker.on('select', (e) => {
        const { start, end } = e.detail

        const form = input.closest('.hero-form')
        form.classList.add('hero-form--selected')
        form.querySelector('button[type=submit]').disabled = false
        form
          .querySelector('button[type=submit]')
          .classList.remove('smdt-btn--white')
        form
          .querySelector('button[type=submit]')
          .classList.add('smdt-btn--secondary')

        form.querySelector('input[name=start]').value =
          moment(start).format('X')
        form.querySelector('input[name=end]').value = moment(end).format('X')
      })
    },
  })
}
